import GlassCard from './GlassCard';

/**
 * Bento grid stat card — displays a big number with a label and optional icon.
 *
 * @param {string|number} value - The primary metric
 * @param {string} label - Description text
 * @param {React.ReactNode} icon - Optional icon element
 * @param {string} accentColor - CSS color for the icon background
 * @param {string} className - Additional CSS classes
 * @param {object} style - Additional inline styles
 * @param {string} span - Grid span: '2' for double width
 */
export default function StatCard({
  value,
  label,
  icon,
  accentColor = 'var(--accent-primary)',
  className = '',
  style,
  span,
  children,
}) {
  const gridStyle = span === '2' ? { gridColumn: 'span 2' } : {};

  return (
    <GlassCard
      accent
      className={`stat-card ${className}`}
      style={{ ...gridStyle, ...style }}
    >
      {icon && (
        <div
          className="stat-card__icon"
          style={{
            background: `${accentColor}15`,
            color: accentColor,
          }}
        >
          {icon}
        </div>
      )}
      <div className="stat-card__value" style={{ color: accentColor }}>
        {value}
      </div>
      <div className="stat-card__label">{label}</div>
      {children}
    </GlassCard>
  );
}
